import { render, staticRenderFns } from "./merchantPayCryptoRouter.vue?vue&type=template&id=4cd5bd1b"
import script from "./merchantPayCryptoRouter.vue?vue&type=script&lang=js"
export * from "./merchantPayCryptoRouter.vue?vue&type=script&lang=js"
import style0 from "./merchantPayCryptoRouter.vue?vue&type=style&index=0&id=4cd5bd1b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports